"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uncrunch = void 0;
const utils_1 = require("../utils");
const JSON_1 = require("../JSON");
function expand(data, expanded) {
    const recurse = (data) => expand(data, expanded);
    if ((0, utils_1.isReference)(data)) {
        return expanded[(0, utils_1.decode)(data)];
    }
    if ((0, JSON_1.isContainer)(data)) {
        return (0, JSON_1.map)(data, recurse);
    }
    return (0, utils_1.decode)(data);
}
function uncrunch(values) {
    const expanded = [];
    expanded.length = values.length; // Hint at array length for perf boost.
    for (let i = 0; i < values.length; i++) {
        expanded[i] = expand(values[i], expanded);
    }
    return expanded[expanded.length - 1];
}
exports.uncrunch = uncrunch;
